/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";
import { colors } from "../../../constants/colors";
import { useSpinnersContext } from "../../../contexts/spinnersContext";

/* Styles */
import styles from "./styles.js"


const Footer = props => {
  const { setShowModal, handleSaveModal, disableSubmit, submitText, cancelCallback, btnSpinner } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const spinner = useSpinnersContext();

  const handleCancel = () => {
    if (cancelCallback) {
      cancelCallback();
    }
    setShowModal(false);
  }

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={handleCancel}
            type="default"
            className={classes.cancelBtn}
            disabled={spinner.deleteCompanyActionSpinner}
            text={<FormattedMessage id="peopleGrid.deleteAction.cancel"/>}
          />
        </Col>
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={`${classes.saveBtn} ${disableSubmit ? classes.customDisabled : ''}`}
            onClick={handleSaveModal}
            type="danger"
            text={submitText ? submitText : <FormattedMessage id="peopleGrid.deleteAction.delete"/>}
            dataTestId="changelanguagesubmit"
            disabled={ disableSubmit }
            loadingStateStyling={ classes.customDisabled }
            spinner={{
              name: btnSpinner ? btnSpinner : (spinner.deleteCompanyActionSpinner ? "deleteCompanyActionSpinner" : "deleteActionSpinner"),
              size: 20,
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default Footer;
